import { useContext, useEffect, useState } from 'react';
import { Button, Checkbox, CheckboxProps, DatePicker, Dropdown, Form, MenuProps } from 'antd';
import { useForm } from 'antd/es/form/Form';

import leafPng from 'assets/images/leaf.png';
import ModalTask from '../../../../../components/BorrowerTask/components/Organisms/Modals/ModalTask/ModalTask';
import { LoanContext } from '../LoanDetails';
import './CreateLoanDoc.scss';
import InputBorderNone from '../../../../../components/BorrowerTask/components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import CardUploadResponse from '../../../../../components/BorrowerTask/components/Atoms/Cards/CardUploadResponse/CardUploadResponse';
import { useCreateLoanDoc, useDeleteFileLoanDoc } from '../../../../../services/loan/mutations';
import { LoanDocState, ReplicationStrategy } from '../../../../../gql/graphql';
import moment from 'moment';
import { useGetTasksByLoan } from '../../../../../services/task/querys';
import DropdownBasic from '../../../../../components/Dropdowns/DropdownBasic/DropdownBasic';
import { useGetLoanDocByLoan } from '../../../../../services/loan/querys';
import CheckboxBasic from '../../../../../components/Atoms/Checkboxs/CheckboxBasic/CheckboxBasic';
import { LimitFiles } from './const';

interface Props {
  selectLoanDoc?: any;
  loanDocs?: any[];
  setSelectLoanDoc: Function;
}

const CreateLoanDoc = ({ selectLoanDoc, setSelectLoanDoc, loanDocs }: Props) => {
  const [form] = useForm();
  const loanSelected: any = useContext(LoanContext);

  const { execute: deleteFileLoanDoc } = useDeleteFileLoanDoc();
  const { reexecute: getLoanDocByLoan } = useGetLoanDocByLoan({ variables: { loanId: loanSelected?._id }, pause: true });
  const { reexecute: getTasksByLoan } = useGetTasksByLoan({
    variables: { loanId: loanSelected?._id },
    pause: true
  });
  const { execute: createLoanDoc, fetching } = useCreateLoanDoc();

  const [isModalTaskVisible, setModalTaskVisible] = useState(false);
  const [statusLoanDoc, setStatusLoanDoc] = useState<string>();
  const [fileLoanDoc, setFileLoanDoc] = useState<any[]|undefined>(undefined);
  const [expiration, setExpirationDate] = useState<any>();
  const [isOwner, setIsOwner] = useState<boolean>();
  const [isSelectChanged, setIsSelectChanged] = useState<boolean>(false);

  useEffect(() => {
    if (!isModalTaskVisible) {
      setStatusLoanDoc(undefined);
      form.resetFields();
    }
  }, [isModalTaskVisible])

  useEffect(() => {
    if (selectLoanDoc) {

      setModalTaskVisible(true);

      form.setFieldValue("name", selectLoanDoc.label);

      const isLoanDoc = loanDocs?.find(item =>
        item.key === selectLoanDoc?.key || item._id === selectLoanDoc?._id
      );
      
      if (isLoanDoc?.expiration){
        form.setFieldValue("expiration", moment(isLoanDoc?.expiration));
        setExpirationDate(moment(isLoanDoc?.expiration));
      }

      if (isLoanDoc?.state)
        setStatusLoanDoc(isLoanDoc.state);

      if(isLoanDoc)
        setIsOwner(!!isLoanDoc.ownership);
    }
  }, [selectLoanDoc]);
  
  const onFinish = async (file: any) => {
    const isLoanDoc = loanDocs?.find(item => item.key === selectLoanDoc?.key || selectLoanDoc?._id === item._id);

    let newState = statusLoanDoc || LoanDocState.Pending;

    if(file && isOwner) newState = LoanDocState.Approved;
    //Tiene archivo y es nuevo
    if(file && !isLoanDoc) newState = LoanDocState.Approved;
    if(file.length > 1) newState = LoanDocState.Approved;
    if(statusLoanDoc === LoanDocState.Pending && selectLoanDoc?.key !== undefined && selectLoanDoc?.key !== 'closing_docs'){
      form.setFieldsValue({
        expiration: undefined
      });
      await createLoanDoc({
        _id: isLoanDoc?._id,
        key: selectLoanDoc?.key,
        loan: loanSelected._id,
        state: LoanDocState.Pending,
      });
      if (isLoanDoc && isLoanDoc?.file){
        deleteFileLoanDoc({ fileKey: isLoanDoc.file.key, loanDocId: isLoanDoc._id })
        setFileLoanDoc([])
      }
    } else {
      const payload = {
        ...form.getFieldsValue(),
        _id: isLoanDoc?._id,
        key: selectLoanDoc?.key,
        loan: loanSelected._id,
        state: newState,
        replicationStrategy: ReplicationStrategy.CopyToAll
      }
      if (file?.length > 1) {
        payload.files = isLoanDoc?.files?.length > 0 ? null : file;
      } else {
        payload.file = isLoanDoc?.file ? null : file[0];
      }
      await createLoanDoc(payload);
    }
    if (!selectLoanDoc) {
      form.resetFields();
      setModalTaskVisible(false);
    }
    setIsSelectChanged(false);

    getLoanDocByLoan({ requestPolicy: 'network-only' });
    getTasksByLoan({ requestPolicy: 'network-only' });
  }

  const handlerOpenModal = (action: any) => {
    action(true)
    setSelectLoanDoc();
    form.resetFields();
  }

  const handlerSelectStatus = async (value: string) => {
    setStatusLoanDoc(value);
    setIsSelectChanged(true);
  }

  const onDeleteFile = (fileToDelete: any) => {
    if (isLoanDoc && isLoanDoc.file) {
      deleteFileLoanDoc({ fileKey: isLoanDoc.file.key, loanDocId: isLoanDoc._id })
      setFileLoanDoc([]);
    }
    if (isLoanDoc && isLoanDoc.files && fileToDelete?.key) {
      deleteFileLoanDoc({ fileKey: fileToDelete.key, loanDocId: isLoanDoc._id, multipleFiles: true })
      setFileLoanDoc((prev) => prev?.filter((file) => file.key !== fileToDelete.key));
    }
    if (isLoanDoc === undefined && selectLoanDoc?.key === 'term_sheet') {
      if (fileLoanDoc && fileLoanDoc[0]) {
        deleteFileLoanDoc({ fileKey: fileLoanDoc[0]?.key, loanDocId: null, taskKey: selectLoanDoc?.key })
        setFileLoanDoc([])
      }
    }
  }

  const onHideDoc: CheckboxProps['onChange'] = async (e) => {
    const isLoanDoc = loanDocs?.find(item => item.key === selectLoanDoc?.key || selectLoanDoc?._id === item._id);

    await createLoanDoc({
      ...form.getFieldsValue(),
      _id: isLoanDoc?._id,
      key: selectLoanDoc?.key,
      loan: loanSelected._id,
      hidden: e.target.checked,
      state: statusLoanDoc || LoanDocState.Pending
    });

    getLoanDocByLoan({ requestPolicy: 'network-only' });
    getTasksByLoan({ requestPolicy: 'network-only' });
  };

  const isLoanDoc = loanDocs?.find(item => item.key === selectLoanDoc?.key || item._id === selectLoanDoc?._id);

  const status: any = {
    appraisal: [
      { key: 'PENDING', label: "None selected"},
      { key: 'ORDERED', label: "Appraisal ordered" },
      { key: 'RECEIVED', label: "Appraisal received" },
      { key: 'APPROVED', label: "Appraisal approved" },
    ],
    insurance: [
      { key: 'PENDING', label: "None selected"},
      { key: 'CONTACTED', label: "Insurance agent contacted" },
      { key: 'RECEIVED', label: "Insurance documents received" },
      { key: 'APPROVED', label: "Insurance documents approved" },
    ],
    title: [
      { key: 'PENDING', label: "None selected"},
      { key: 'REQUESTED', label: "Title requested" },
      { key: 'VERIFIED', label: "Title verified" },
      { key: 'CLEARED', label: "Title cleared to close" },
    ]
  };

  const checkDisabled = [
    'credit_report',
    'background_check',
  ];

  const hiddenCheckboxDisabled = [
    'term_sheet',
    'pre_approval'
  ];

  const expirationDate = [
    { key: 'appraisal', expirationRequired: false },
    { key: 'insurance', expirationRequired: true },
    { key: 'title', expirationRequired: false },
  ];

  useEffect(() => {
    const found = loanDocs?.find(item =>
      item.key === selectLoanDoc?.key || item._id === selectLoanDoc?._id
    );
    let initial: any[]|undefined = found?.file && found?.files?.length === 0 ? [found.file] : found?.files ? found.files : undefined;

    if (!initial && selectLoanDoc && loanSelected.onboarding) {
      const mapKey: any = { term_sheet: 'termSheetURL', pre_approval: 'preApprovalLetterUrl' };
      const url = loanSelected.onboarding[ mapKey[selectLoanDoc.key] ];
      if (url) {
        const name = url.split('/').pop();
        initial = [{ key: name, name, url }];
      }
    }
    setFileLoanDoc(initial);
  }, [loanDocs, selectLoanDoc, loanSelected.onboarding]);

  const rulesExpiration = expirationDate.find(item => item.key === selectLoanDoc?.key);
  const isCreditReportOrBackgroundCheck = selectLoanDoc?.label.includes('Credit Report') || selectLoanDoc?.label.includes('Background Check');
  const hasDropdown = selectLoanDoc?.key !== undefined && selectLoanDoc?.key !== 'closing_docs';
  const disabledClosingDocs = selectLoanDoc?.key === 'closing_docs' && fileLoanDoc && fileLoanDoc?.length > 0;
  return (
    <ModalTask
      visible={isModalTaskVisible}
      handlerSetVisibile={setModalTaskVisible}
      renderButtonTrigger={(openModal: any) => (
        <div className='action-button' onClick={() => handlerOpenModal(openModal)} style={{ cursor: 'pointer' }}>
          Upload loan document
        </div>
      )}
      header={{
        title: <span>{loanSelected.owner.name + ' ' + loanSelected.owner.lastname} | {loanSelected.name}</span>,
        actionLeft: (<img src={leafPng} alt="icon" className="paperPng" />)
      }}
      animationDirection="onRight"
      dots={false}
      stepsTotal={1}
      currentStep={1}
      setStep={() => { }}
      footer={<></>}
    >
      <div className='CreateLoanDoc'>
        <section>
          {!selectLoanDoc && 
            <h2 className="h2">
              Upload a loan document for{' '}
              <span>{loanSelected.owner.name + ' ' + loanSelected.owner.lastName} {loanSelected.type}</span>
              {' '}loan in {loanSelected.name}
            </h2>
          } 
          {selectLoanDoc && 
            <h2 className="h2">What is the status of {selectLoanDoc?.label} {selectLoanDoc?.label === 'title' || selectLoanDoc?.label === 'insurance'? 'Documents': ''}?</h2>
          }

          {selectLoanDoc?.key && selectLoanDoc.key !== 'term_sheet' && selectLoanDoc.key !== 'pre_approval' && selectLoanDoc.key !== 'closing_docs' &&
            <DropdownBasic
              className='mt-20'
              label="Select status"
              items={status[selectLoanDoc.key] || []}
              selected={statusLoanDoc}
              onClickSelect={handlerSelectStatus}
            />
          }

          <Form
            form={form}
            name="basic"
            className='form'
            autoComplete="off"
            onFinish={onFinish}
          >
            <CardUploadResponse
              title=""
              titleLocation='outside'
              limitFiles={selectLoanDoc?.key === 'closing_docs' ? LimitFiles.CLOSING_DOCS : LimitFiles.DEFAULT}
              actionDeleteFile={onDeleteFile}
              files={fileLoanDoc}
              submit={{
                title: selectLoanDoc?.key !== undefined ? 'Publish to borrower' : 'Save change',
                disabled: hasDropdown ? !isSelectChanged || (rulesExpiration?.expirationRequired ? !expiration : false)
                  : (rulesExpiration?.expirationRequired ? !expiration : disabledClosingDocs ? true : false),
                loading: fetching,
                modalConfirm: true,
                confirmDescription:
                  "After submitting, you'll have to contact us to make any changes.",
                onClick: (files) => onFinish(files),
                location: 'outside'
              }}
              hasDropdown={hasDropdown}
              insertHtml={
                <div className='doc-info'>
                  <Form.Item
                    name="name"
                    className='form-item-doc-name'
                    style={{ marginBottom: 0 }}
                    rules={[
                      {
                        required: true,
                        message: 'Please input your doc name!'
                      }
                    ]}
                  >
                    <InputBorderNone
                      placeholder="Enter doc name"
                      className="form-task-name"
                      color="bold"
                      disabled={selectLoanDoc}
                    />
                  </Form.Item>

                  {!selectLoanDoc &&
                    <Form.Item
                      name="description"
                      style={{ marginBottom: 15 }}
                    >
                      <InputBorderNone
                        placeholder="Enter document description (optional)"
                        className="form-doc-description"
                      />
                    </Form.Item>
                  }

                  {rulesExpiration &&
                    <Form.Item
                      name="expiration"
                      style={{ marginTop: 20 }}
                      rules={[
                        {
                          required: rulesExpiration.expirationRequired,
                          message: 'Please input date expiration!'
                        }
                      ]}
                    >
                      <DatePicker
                        className="form-doc-expiration"
                        placeholder={"Expiration" + (rulesExpiration.expirationRequired ? '' : ' (optional)')}
                        onChange={(v) => setExpirationDate(v)}
                        suffixIcon={null}
                        format={"MM/DD/YYYY"}
                      />
                    </Form.Item>
                  }

                </div>
              }
            />
          </Form>
          <div className='hide-doc'>
            <CheckboxBasic
              defaultChecked={checkDisabled.includes(selectLoanDoc?.key) || isLoanDoc?.hidden}
              onChange={onHideDoc}
              label='Hide this doc from the borrower'
              disabled={hiddenCheckboxDisabled.includes(selectLoanDoc?.key) || checkDisabled.includes(selectLoanDoc?.key) || isCreditReportOrBackgroundCheck}
            />
          </div>
        </section>
      </div>
    </ModalTask>
  );
};
export default CreateLoanDoc;